import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./auth/LoginStyles.css";
import { APP_LOGO_URL } from "../config/branding";

function RegistrationSuccess() {
  const location = useLocation();
  const navigate = useNavigate();

  // Get email from URL query or location state
  const params = new URLSearchParams(location.search);
  const email = params.get("email") || location.state?.email || "your email";

  return (
    <div className="login-page">
      {/* Left Panel - Branding */}
      <div className="login-branding">
        <div className="branding-content">
          <div className="branding-logo"><img src={APP_LOGO_URL} alt="OGESTYLE" style={{ maxWidth: "160px", height: "auto" }} /></div>
          <h1 className="branding-title">OGESTYLE</h1>
          <p className="branding-subtitle">
            The complete platform to grow your beauty business
          </p>
          <div className="branding-features">
            <div className="branding-feature">
              <div className="branding-feature-icon">📈</div>
              <span className="branding-feature-text">
                Manage staff & bookings effortlessly
              </span>
            </div>
            <div className="branding-feature">
              <div className="branding-feature-icon">💳</div>
              <span className="branding-feature-text">
                Secure payments & instant payouts
              </span>
            </div>
            <div className="branding-feature">
              <div className="branding-feature-icon">💎</div>
              <span className="branding-feature-text">
                Sell products & manage inventory online
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Right Panel - Success Message */}
      <div className="login-form-panel">
        <div className="login-container">
          <div style={{ textAlign: "center" }}>
            {/* Success Icon */}
            <div
              style={{
                width: "80px",
                height: "80px",
                background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 24px",
                fontSize: "40px",
              }}
            >
              ✉️
            </div>

            <h2
              style={{
                fontSize: "28px",
                fontWeight: "700",
                marginBottom: "16px",
                color: "#0f172a",
              }}
            >
              Registration Complete!
            </h2>

            <p
              style={{
                fontSize: "16px",
                color: "#64748b",
                marginBottom: "24px",
                lineHeight: "1.6",
              }}
            >
              We've sent a verification email to{" "}
              <strong style={{ color: "#0f172a" }}>{email}</strong>
            </p>

            {/* Next Steps Box */}
            <div
              style={{
                padding: "20px",
                background: "#f0f9ff",
                borderRadius: "12px",
                marginBottom: "24px",
                textAlign: "left",
                border: "1px solid #bae6fd",
              }}
            >
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#0c4a6e",
                  marginBottom: "12px",
                }}
              >
                📋 Next Steps:
              </p>
              <ol
                style={{
                  fontSize: "14px",
                  color: "#334155",
                  lineHeight: "1.8",
                  margin: 0,
                  paddingLeft: "20px",
                }}
              >
                <li>Check your email inbox for the verification email</li>
                <li>Click the verification link in the email</li>
                <li>
                  Log in with your credentials to complete your business setup
                </li>
              </ol>
            </div>

            {/* Spam Folder Reminder */}
            <div
              style={{
                padding: "16px",
                background: "#fef3c7",
                borderRadius: "8px",
                marginBottom: "24px",
                border: "1px solid #fde68a",
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  color: "#92400e",
                  margin: 0,
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <span style={{ fontSize: "18px" }}>💡</span>
                <span>
                  <strong>Can't find the email?</strong> Check your spam or junk
                  folder. The email is sent from Ogestyle.
                </span>
              </p>
            </div>

            {/* Go to Login Button */}
            <button
              onClick={() => navigate("/login")}
              style={{
                width: "100%",
                padding: "14px 24px",
                background: "linear-gradient(135deg, #1a365d 0%, #2563eb 100%)",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "transform 0.2s, box-shadow 0.2s",
              }}
              onMouseOver={(e) => {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 4px 12px rgba(37, 99, 235, 0.3)";
              }}
              onMouseOut={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "none";
              }}
            >
              Go to Login Page
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegistrationSuccess;
